import React, { useEffect, useState } from 'react'
import LoginHoc from '../../../shared/hoc/login/Login.hoc'
import style from './Login.module.scss'
import logo from '../../../assets/images/logo.svg'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { updateAccessTokenAndLoginStatus } from '../../../store/reducers/AuthSlice'
import { useCookies } from 'react-cookie'
import { gql, useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack';
import jwt_decode from "jwt-decode";
import { stopPageLoading } from '../../../store/reducers/AppSlice'

const LeftContent: React.FC = () => {
  return (
    <div className={style.left_content_wrapper}>

    </div>
  )
}

const SUBMIT_LOGIN_DETAILS = gql`mutation Mutation($email: String!, $password: String!) {
  Login(email: $email, password: $password) {
    errors
    success
    token {
      accessToken
      refreshToken
    }
  }
}
`;


export default function LoginPage() {

  const [submitLoginDetails, { data: LoginData, loading, error }] = useMutation(SUBMIT_LOGIN_DETAILS);

  const dispatch = useDispatch()

  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();


  const [cookies, setCookie] = useCookies(['token', 'refreshToken'])

  const [hasErrors, setHasErrors] = useState(false)

  const [errors, setErrors] = useState([])

  dispatch(stopPageLoading())




  const signIn = async (data: any) => {

    let res = await submitLoginDetails({ variables: { email: data.email, password: data.password } })

    if (!res.data.Login.success) {
      enqueueSnackbar(res.data.Login.errors[0], { variant: "error" });
    }
    else {

      var decoded = jwt_decode(res.data.Login.token.accessToken);
      dispatch(updateAccessTokenAndLoginStatus({ token: res.data.Login.token.accessToken, isLoggedIn: true, decodedTokenData: decoded }));
      setCookie('token', res.data.Login.token.accessToken, { path: '/' })
      
      setCookie('refreshToken', res.data.Login.token.refreshToken, { path: '/' })
      let redirectPath = localStorage.getItem('redirectPath');
      if(redirectPath) {
        navigate(redirectPath);
        // localStorage.removeItem('redirectPath');
      } else {
        navigate('/admin/dashboard');
      }
    }
  }



  return (
    <div>

      <LoginHoc
        LeftContent={LeftContent}
        hasError={hasErrors}
        errors={errors}
        logo={<img src={logo} className={style.logo} alt='' />}
        forgotPasswordClick={() => {
          navigate('/reset-password/email');
        }}
        onLogin={signIn}
      />
    </div>
  )

}
